import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  updateStatus(event) {
    const select = event.target
    const form = this.formTarget
    
    // Zeige Loading-Animation
    const originalValue = select.value
    select.disabled = true
    select.classList.add('opacity-50', 'cursor-not-allowed')
    
    // Füge einen kleinen Spinner hinzu
    const spinner = document.createElement('div')
    spinner.className = 'inline-block w-3 h-3 border border-gray-300 border-t-blue-600 rounded-full animate-spin ml-2'
    select.parentNode.appendChild(spinner)
    
    // Sende das Formular ab
    form.requestSubmit()
  }
}
